export const JOB_COUNT_PER_PAGE = 50;
